import { unbrand, unbrandIcon } from "@/helpers/brand";
import Request from './baseRequest'

const integrationTypes = [
	{
		name: "Gopersonal",
		icon: "https://public-assets.gopersonal.ai/uploads/2026/07/5e5fe2bd-fc33-430e-9f0b-3845bf35359d.svg",
		type: 'go_shops_web',
		group: 'go_shops',
		fields: [{
			key: "name",
			name: "Name",
			type: 'text'
		},
		{
			key: "sessionExpirationTime",
			name: "Session Expiration Time (hs)",
			type: 'number',
			value: 24
		}
		]
	},
	{
		name: "Gopersonal Apikey",
		icon: "https://public-assets.gopersonal.ai/uploads/2026/07/5e5fe2bd-fc33-430e-9f0b-3845bf35359d.svg",
		type: 'go_shops_apikey',
		group: 'go_shops',
		fields: [{
			key: "name",
			name: "Name",
			type: 'text'
		}
		]
	},
	{
		name: "Calvin",
		icon: "https://public-assets.gopersonal.ai/uploads/2026/07/5e5fe2bd-fc33-430e-9f0b-3845bf35359d.svg",
		type: 'calvin',
		group: 'calvin',
		fields: [
			{
				key: "name",
				name: "Name",
				type: 'text'
			},
			{
				key: "api_key",
				name: "API Key",
				type: 'password'
			},
		],
		
	},
	{
		name: "Magento",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/03/fe1620b6-3f99-46ad-8222-58752bda8c5a.png",
		type: 'magento',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "oauth",
				name: "Use OAuth 1.0 for GraphQL",
				type: 'checkbox',
				required: false
			},
			{
				key: "token",
				name: "Token",
				type: 'password'
			},
			{
				key: "consumer_key",
				name: "Consumer Key",
				type: 'text', 
				required: false
			},
			{
				key: "consumer_secret",
				name: "Consumer Secret",
				type: 'password',
				required: false
			},
			{
				key: "access_token",
				name: "Access Token Key",
				type: 'text',
				required: false
			},
			{
				key: "access_token_secret",
				name: "Access Token Secret",
				type: 'password',
				required: false
			},
			{
				key: "store",
				name: "Store",
				type: 'text',
				required: false
			},
			{
				key: "use_live_shop",
				name: "Use Live Shopping",
				type: "checkbox"
			},
			{
				key: "only_simple_products",
				name: "Use only simple products",
				type: 'checkbox'
			},
			{
				key: "parse_products",
				name: "parse_products",
				type: 'text'
			},
			{
				key: "custom_product_query",
				name: "custom_product_query",
				type: 'text',
				default: `query GetProducts($pageSize: Int!, $currentPage: Int!) {
  products(search: "", pageSize: $pageSize, currentPage: $currentPage) {
    items {
      id
      sku
      name
      short_description {
        html
      }
      stock_status
      price_range {
        minimum_price {
          regular_price {
            value
            currency
          }
          final_price {
            value
            currency
          }
        }
      }
      media_gallery_entries {
        file
        position
      }
      categories {
        id
        name
      }
      url_key
    }
  }
}`
			},
			{
				key: "extra_fields_product",
				name: "extra_fields_product",
				type: 'text',
				required: false
			},
			{
				key: "custom_image_base_url_product",
				name: "custom_image_base_url_product",
				type: 'text',
				required: false
			},
			{
				key: "filter_by_categories",
				name: "filter_by_categories",
				type: 'checkbox'
			}
		]
	},
	{
		name: "WooCommerce",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/01/70d1fdf8-fd33-4711-a9e3-299a6d54fa21.png",
		type: 'woocomerce',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "consumer_key",
				name: "consumer key",
				type: 'text'
			},
			{
				key: "consumer_secret",
				name: "consumer secret",
				type: 'password'
			},
		]
	},
	{
		name: "Email",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/03/1b3d28fa-686e-438e-90d8-2437dce326e8.png",
		type: 'email',
		group: 'channel',
		fields: [
			{
				key: "domain",
				name: "Domain",
				type: 'url'
			},
			{
				key: "displayName",
				name: "Display Name",
				type: 'text'
			},
			{
				key: "email",
				name: "Email",
				type: 'email'
			},
			{
				key: "provider",
				name: "Provider",
				type: 'text'
			},
			{
				key: "replyTo",
				name: "Reply To",
				type: 'text'
			},
		]
	},
	{
		name: "SMTP Server",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/458ca607-a5e6-47bc-913a-9ba44992f3b2.webp",
		type: 'smtp_email',
		group: 'channel',
		fields: [
			{
				key: "address",
				name: "Address",
				type: 'text'
			},
			{
				key: "port",
				name: "Port",
				type: 'number'
			},
			{
				key: "smtp_login",
				name: "SMTP Login",
				type: 'text'
			},
			{
				key: "smtp_password",
				name: "SMTP Password",
				type: 'password'
			},
		]
	},
	{
		name: "Twilio SMS",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/04/f95984f6-6c0d-4fe9-9793-d3dcfa5a06ff.png",
		type: 'sms',
		group: 'channel',
		fields: [
			{
				key: "accountSid",
				name: "Account SID",
				type: 'text'
			},
			{
				key: "authToken",
				name: "Auth Token",
				type: 'password'
			},
			{
				key: "fromNumber",
				name: "From Number",
				type: 'text'
			},
			{
				key: "fromName",
				name: "From Name",
				type: 'text'
			},
		]
	},
	{
		name: "Go BOT",
		icon: "https://go-live.fra1.digitaloceanspaces.com/uploads/2023/08/3df3b748-aef5-43cb-8f9a-bb6edcea3e5e.svg",
		type: 'go_chatbot',
		group: 'other',
		fields: [
			{
				key: "use_personal_shopper",
				name: "Use Personal Shopper",
				type: "checkbox"
			},
		]
	},
	{
		name: "App Push Notification",
		icon: "https://go-shops.nyc3.digitaloceanspaces.com/uploads/2023/10/bc42c2eb-11e9-43dc-b342-498159fe3612.svg",
		type: 'app_push',
		group: 'channel',
		fields: [
			{
				key: "server_key",
				name: "Firebase Server key (json)",
				type: "file",
				format: 'application/json'
			},
		]
	},
	{
		name: "Feed",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/b77db584-4a5e-40c6-884b-f732f9850229.webp",
		type: 'feed_url',
		group: 'feed',
		fields: [],
		hidden_sync: {
			products: false,
			customers: true,
			interactions: true
		}
	},
	{
		name: "Customers BigQuery",
		icon: "https://public-assets.goshops.ai/bigquery.png",
		type: 'customers',
		group: 'feed_customers',
		fields: [
			{
				key: "credentials",
				name: "credentials",
				type: 'password'
			},
			{
				key: "query",
				name: "query",
				type: 'text'
			},
			{
				key: "fields",
				name: "fields",
				type: 'text'
			}
		],
		hidden_sync: {
			products: false,
			customers: false,
			interactions: false
		}
	},
	{
		name: "Fenicio",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/905eed83-5c4f-4875-b56b-2c497a418573.jpg",
		type: 'fenicio',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "parse_products",
				name: "parse_products",
				type: "text"
			},
			{
				key: "separateVariantByURL",
				name: "Separar variantes por URL",
				type: "checkbox"
			},
			{
				key: "url_endpoint",
				name: "url_endpoint",
				type: "text"
			},
			{
				key: "customers_turso_url",
				name: "customers_turso_url",
				type: "text",
				required: false
			},
			{
				key: "customers_turso_token",
				name: "customers_turso_token",
				type: "text",
				required: false
			},
			{
				key: "interactions_overrideTopSellers",
				name: "interactions_overrideTopSellers",
				type: "checkbox",
				required: false
			},
			{
				key: "interactions_overridePopulars",
				name: "interactions_overridePopulars",
				type: "checkbox",
				required: false
			},
			{
				key: "interactions_filter",
				name: "interactions_filter",
				type: "text",
				required: false
			},
			{
				key: "customXML",
				name: "XML Personalizado",
				type: "text",
				required: false
			},
			{
				key: "productGroupIds",
				name: "ID de grupos para el parse",
				type: "text",
				required: false
			}
		],
		hidden_sync: {
			products: false,
			customers: false,
			interactions: false
		}
	},
	{
		name: "Shopify",
		icon: "https://cdn.brandfetch.io/idAgPm7IvG/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B",
		type: 'shopify',
		group: 'feed',
		fields: [
			{
				key: "shop",
				name: "URL",
				type: 'url'
			},
			{
				key: "parse_products",
				name: "Parse Function",
				type: "text"
			},
			{
				key: "accessToken",
				name: "Access Token",
				type: "text"
			},
			{
				key: "custom_query",
				name: "Custom GraphQL Query to get products",
				type: "text",
				required: false,
				default: `query GetProducts($pageSize: Int!, $cursor: String) {
products(first: $pageSize, after: $cursor) {
  edges {
    node {
      id
      title
      handle
      description
      descriptionHtml
      status
      productType
      vendor
      tags
      isGiftCard
      category {
        id
        name
        fullName
      }
      onlineStoreUrl
      onlineStorePreviewUrl
      createdAt
      updatedAt
      publishedAt

      seo {
        title
        description
      }

      priceRangeV2 {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        minVariantCompareAtPrice {
          amount
          currencyCode
        }
        maxVariantCompareAtPrice {
          amount
          currencyCode
        }
      }

      media(first: 10) {
        edges {
          node {
            id
            mediaContentType
            status
            ... on MediaImage {
              image {
                url
                altText
                width
                height
              }
            }
            ... on Video {
              sources {
                url
                mimeType
              }
              preview {
                image {
                  url
                  altText
                }
              }
            }
          }
        }
      }

      featuredMedia {
        ... on MediaImage {
          image {
            url
            altText
            width
            height
          }
        }
      }

      variants(first: 100) {
        edges {
          node {
            id
            title
            sku
            price
            compareAtPrice
            inventoryQuantity
            availableForSale
            barcode
            position

            selectedOptions {
              name
              value
            }

            image {
              url
              altText
              width
              height
            }

            contextualPricing(context: {country: US}) {
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }

      options {
        id
        name
        values
        position
      }

      collections(first: 30) {
        edges {
          node {
            id
            title
            handle
          }
        }
      }

      totalInventory
      tracksInventory

      metafields(first: 20) {
        edges {
          node {
            id
            namespace
            key
            value
            type
          }
        }
      }
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
}`
			},
			{
				key: "resolve_metafields",
				name: "Metafields a resolver (ej: shopify.color-pattern)",
				type: "string",
				required: false
			},
			{
				key: "translation_locales",
				name: "Idiomas a traducir (ej: en,pt-PT)",
				type: "string",
				required: false
			},
		],
		hidden_sync: {
			products: false,
			customers: false,
			interactions: false
		}
	},
	{
		name: "Custom",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/347c359e-f608-44ef-a4ca-86d7de41d853.png",
		type: 'custom',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "parse_products",
				name: "parse_products",
				type: "text"
			},
			{
				key: "parse_data",
				name: "parse_data",
				type: "text"
			},
		],
		hidden_sync: {
			products: false,
			customers: false,
			interactions: false
		}
	},
	{
		name: "Magento Rest",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/03/fe1620b6-3f99-46ad-8222-58752bda8c5a.png",
		type: 'magento_rest',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "parse_products",
				name: "Funcion de parseo de productos",
				type: "text"
			},
			{
				key: "consumer_key",
				name: "Consumer Key",
				type: "password",
				required: false
			},
			{
				key: "consumer_secret",
				name: "Consumer Secret",
				type: "password",
				required: false
			},
			{
				key: "access_token",
				name: "Access Token",
				type: "password"
			},
			{
				key: "access_token_secret",
				name: "Token Secret",
				type: "password",
				required: false
			},
			{
				key: "store_id",
				name: "Store",
				type: "text",
				required: false
			},
			{
				key: "visibility",
				name: "Visibility",
				type: "number",
				required: false
			},
			{
				key: "status",
				name: "Status",
				type: "number",
				required: false
			},
			{
				key: "custom_path",
				name: "Custom Path",
				type: "text",
				required: false
			},
			{
				key: "custom_params",
				name: "Custom Parameters",
				type: "text",
				required: false
			},
			{
				key: "token_type",
				name: "Bearer Token",
				type: "checkbox",
				required: false
			},
			{
				key: "amasty_enabled",
				name: "Obtener Tags de Amasty",
				type: "checkbox",
				required: false
			},
			{
				key: "graphql_enrichment_enabled",
				name: "Enriquecer con datos GraphQL",
				type: "checkbox",
				required: false
			},
			{
				key: "resolve_attributes",
				name: "Atributos a resolver",
				type: "string",
				required: false
			},
			{
				key: "proxy",
				name: "HTTP Proxy (opcional)",
				type: "text",
				required: false
			}
		],
		hidden_sync: {
			products: false,
			customers: true,
			interactions: true
		}
	},
	{
		name: "VTEX",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/a43cf95e-d89a-41b9-bdd8-22a9938c3c85.jpeg",
		type: 'vtex',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			},
			{
				key: "appKey",
				name: "App Key",
				type: 'text'
			},
			{
				key: "appToken",
				name: "App Token",
				type: 'password'
			},
			{
				key: "largeCatalog",
				name: "Large Catalog",
				type: "checkbox"
			},
			{
				key: "product_url",
				name: "Product Url",
				type: "text"
			},
			{
				key: "parse_products",
				name: "parse_products",
				type: "text"
			},
			{
				key: "has_split_by_field",
				name: "Has split by field",
				type: "checkbox",
				required: false
			},	
			{
				key: "split_by_field_field",
				name: "Split by field (field)",
				type: "text",
				required: false
			}	
		],
	},
	{
		name: "Web Push Notification",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/05/3474997c-5e3d-4a39-a56c-af130e693289.png",
		type: 'web_push',
		group: 'channel',
		fields: [
			{
				key: "server_key",
				name: "Firebase Server key (json)",
				type: "file",
				format: 'application/json'
			},
		]
	},
	{
		name: "FTP Customers",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/09/f1cf8bfa-8767-45ab-8ace-1964e7381aaf.png",
		type: 'ftp_customers',
		group: 'feed_customers',
		fields: [
			{
				key: "host",
				name: "Host",
				type: 'text'
			},
			{
				key: "fpt_username",
				name: "Username",
				type: 'text'
			},
			{
				key: "fpt_password",
				name: "Password",
				type: 'password'
			},
			{
				key: "secure",
				name: "Use secure",
				type: "checkbox"
			},
			{
				key: "folder",
				name: "Folder",
				type: "text"
			},
			{
				key: "file_regexp",
				name: "File Name (regexp)",
				type: "text"
			},
			{
				key: "parse",
				name: "Parse Function",
				type: "code"
			},
		]
	},
	{
		name: "FTP Orders",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/09/f1cf8bfa-8767-45ab-8ace-1964e7381aaf.png",
		type: 'ftp_orders',
		group: 'feed_customers',
		fields: [
			{
				key: "host",
				name: "Host",
				type: 'text'
			},
			{
				key: "fpt_username",
				name: "Username",
				type: 'text'
			},
			{
				key: "fpt_password",
				name: "Password",
				type: 'password'
			},
			{
				key: "secure",
				name: "Use secure",
				type: "checkbox"
			},
			{
				key: "folder",
				name: "Folder",
				type: "text"
			},
			{
				key: "file_regexp",
				name: "File Name (regexp)",
				type: "text"
			},
			{
				key: "parse",
				name: "Parse Function",
				type: "code"
			},
			{
				key: "turso_url",
				name: "Turso Url",
				type: "text"
			},
			{
				key: "turso_token",
				name: "Turso Token",
				type: "text"
			},
			{
				key: "processResults",
				name: "Process Results Function",
				type: "code"
			},
			{
				key: "query",
				name: "Consulta SQL",
				type: "code"
			},
		]
	},
	{
		name: "Luna",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/23cfcc22-42fc-4841-9858-bf32584db413.png",
		type: 'luna',
		group: 'feed',
		fields: [
			{
				key: "url",
				name: "URL",
				type: 'url'
			}
		],
	},
	{
		name: "Tiendanube",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/11/5256f2ab-b3ae-41b0-99b6-87f47d690fe6.png",
		type: 'tiendanube',
		group: 'feed',
		fields: [
			{
				key: "store_id",
				name: "Store ID",
				type: 'text'
			},
			{
				key: "access_token",
				name: "Token",
				type: 'password'
			},
			{
				key: "parse_products",
				name: "Funcion de Parseo de Productos",
				type: 'text'
			}
		],
		hidden_sync: {
			products: false,
			customers: true,
			interactions: true
		}
	},
	{
		name: "Customers CSV",
		icon: "https://gs-prod-public.goshops.ai/uploads/2024/12/96645d44-724e-4373-84d3-e0cf3b299bfe.png",
		type: 'feed_customers_csv',
		group: 'feed_customers',
		fields: [
			{
				key: "parse",
				name: "Parse Function",
				type: "code",
				standard: `function mapColumns(data) {
          return data.map(row => {
            return row
          });
        }`
			},
			
		]
	},
	{
		name: "Feed Customers",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/25707cdf-7567-4ba5-adce-32cc8e31f386.webp",
		type: 'feed_customers_url',
		group: 'feed_customers',
		fields: [],
		hidden_sync: {
			products: true,
			customers: false,
			interactions: true
		}
	},
	{
		name: "Facebook Ads",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/03/3fdb892e-066a-41fc-8ccf-48c8b0d0ecdc.png",
		type: 'facebook_ads',
		group: 'channel',
		fields: [
			{
				key: "name",
				name: "Name",
				type: 'text'
			},
			{
				key: "account_id",
				name: "Account ID",
				type: 'text'
			},
			{
				key: "access_token",
				name: "Access Token",
				type: 'password'
			}
		],
		
	},
	{
		name: "WhatsApp",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/e3e1b240-0975-4226-8df7-9b5de8e9ce6c.png",
		type: 'whatsapp',
		group: 'channel',
		fields: [
			{
				key: "name",
				name: "Name",
				type: 'text'
			},
			{
				key: "business_account_id",
				name: "WhatsApp Business Account ID",
				type: 'text'
			},
			{
				key: "phone_number_id",
				name: "Phone Number ID",
				type: 'text'
			},
			{
				key: "access_token",
				name: "Access Token",
				type: 'password'
			},
			{
				key: "app_secret",
				name: "App Secret",
				type: 'password'
			},
			{
				key: "display_name",
				name: "Display Name",
				type: 'text'
			}
		],
		
	},
	{
		// WhatsApp via Zernio: el cliente no carga credenciales, conecta su
		// número con el login de Meta (link de conexión). El resto de `data` lo
		// maneja el backend.
		name: "WhatsApp (Zernio)",
		icon: "https://gs-prod-public.goshops.ai/uploads/2025/07/e3e1b240-0975-4226-8df7-9b5de8e9ce6c.png",
		type: 'whatsapp_zernio',
		group: 'channel',
		fields: [
			{
				key: "name",
				name: "Name",
				type: 'text'
			}
		],
	},
	
]

// En white-label los nombres e íconos no llevan la marca ("Gopersonal Apikey" → "Apikey").
const brandedIntegrationTypes = integrationTypes.map((i) => ({ ...i, name: unbrand(i.name), icon: unbrandIcon(i.icon) }));
export { brandedIntegrationTypes as integrationTypes }
const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _createIntegration = payload => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.post(`${window.config.VUE_APP_BACKEND}/api/integrations`,
		payload,
		config
	)
}

const _getIntegrations = params => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	const url = params ? `${window.config.VUE_APP_BACKEND}/api/integrations?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/integrations`

	return Request.get(url,
		config
	)
}

const _getIntegrationVersions = integrationId => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}/versions`, config)
}

const _deleteIntegration = integrationId => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.delete(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}`, config)
}

const _updateIntegration = (integration) => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.put(`${window.config.VUE_APP_BACKEND}/api/integrations/${integration._id}`, integration, config)
}

const _updateGoShopsIntegration = (autChannel) => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.put(`${window.config.VUE_APP_BACKEND}/api/channel-auths/${autChannel._id}`, autChannel, config)
}

const _createGoShopsIntegration = (autChannel) => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.post(`${window.config.VUE_APP_BACKEND}/api/channel-auths`, autChannel, config)
}

const _getGoShopsIntegration = (autChannelId) => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/channel-auths/${autChannelId}`, config)
}

const _deleteGoShopsIntegration = integrationId => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.delete(`${window.config.VUE_APP_BACKEND}/api/channel-auths/${integrationId}`, config)
}

const _ssoGoShopsIntegration = integrationId => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}/sso`, config)
}

const _syncIntegrationItems = integrationId => {
	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}/test?entity=products`, config)
}

const _bulkFromCsv = (payload) => {
	const token = getUserToken()
	const config = {
		headers: { authorization: `Bearer ${token}` }
	}
	return Request.post(`${window.config.VUE_APP_BACKEND}/api/integrations/${payload.integration}/csv`, payload, config)
}

const _getWhatsappTemplates = integrationId => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}/whatsapp/templates`, config)
}

const _getWhatsappWebhook = integrationId => {

	const token = getUserToken()
	const config = {
		headers: {
			authorization: `Bearer ${token}`
		}
	}

	return Request.get(`${window.config.VUE_APP_BACKEND}/api/integrations/${integrationId}/whatsapp/webhook`, config)
}

const _getZernioConnectLink = ({ id, regenerate = false }) => Request.post(
	`${window.config.VUE_APP_BACKEND}/api/integrations/${id}/zernio/connect-link`,
	{ regenerate },
	{ headers: { authorization: `Bearer ${getUserToken()}` } }
)

const _disconnectZernio = id => Request.post(
	`${window.config.VUE_APP_BACKEND}/api/integrations/${id}/zernio/disconnect`,
	{},
	{ headers: { authorization: `Bearer ${getUserToken()}` } }
)

const PARSE_DRY_RUN_TIMEOUT_MS = 10 * 60 * 1000

const parseRequest = (path, payload, method = 'post', timeout = 90000) => Request[method](
	`${window.config.VUE_APP_BACKEND}/api/integrations/${path}`,
	payload,
	{ headers: { authorization: `Bearer ${getUserToken()}` }, timeout }
);



export default {
	getParseEditor: payload => parseRequest('parse-editor', payload),
	getParseSample: payload => parseRequest('parse-sample', payload),
	runParsePreview: payload => parseRequest('parse-dry-run', payload, 'post', PARSE_DRY_RUN_TIMEOUT_MS),
	saveParse: (id, payload) => parseRequest(`${id}/parse`, payload, 'put'),
	createIntegration: _createIntegration,
	updateIntegration: _updateIntegration,
	deleteIntegration: _deleteIntegration,
	getIntegrations: _getIntegrations,
	getIntegrationVersions: _getIntegrationVersions,
	updateGoShopsIntegration: _updateGoShopsIntegration,
	createGoShopsIntegration: _createGoShopsIntegration,
	getGoShopsIntegration: _getGoShopsIntegration,
	deleteGoShopsIntegration: _deleteGoShopsIntegration,
	ssoGoShopsIntegration: _ssoGoShopsIntegration,
	syncIntegrationItems: _syncIntegrationItems,
	bulkFromCsv: _bulkFromCsv,
	getWhatsappTemplates: _getWhatsappTemplates,
	getWhatsappWebhook: _getWhatsappWebhook,
	getZernioConnectLink: _getZernioConnectLink,
	disconnectZernio: _disconnectZernio
}
